<adapt-filter-content (reset)="resetOptions()"
                      [isDefault]="isDefaultFilter"
                      [width]="380"
                      [urlParamNames]="MeetingFilterParamKeys">
    <div class="form-group d-flex flex-column gap-2">
        <label>Only show meetings with:</label>
        <adapt-select-people [teamGroup]="team"
                             [peopleIds]="currentFilter.peopleIds"
                             (peopleChange)="onPeopleSelectionChanged($event)"></adapt-select-people>
        <dx-check-box text="Decisions"
                      [(value)]="currentFilter.showDecisions"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
        <dx-check-box text="Minutes"
                      [(value)]="currentFilter.showMinutes"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
        <dx-check-box text="Actions"
                      [(value)]="currentFilter.showActions"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
        <dx-check-box text="Objectives"
                      [(value)]="currentFilter.showObjectives"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
    </div>

    <div class="form-group">
        <label>Date range</label>
        <div class="d-flex justify-content-stretch gap-2">
            <dx-date-box type="date"
                         [showClearButton]="true"
                         [value]="currentFilter.fromDate"
                         (valueChange)="fromDateChanged($any($event))"
                         placeholder="From"
                         data-test="meetings-filter-from-date"></dx-date-box>
            <dx-date-box type="date"
                         [showClearButton]="true"
                         [(value)]="currentFilter.toDate"
                         [min]="currentFilter.fromDate"
                         (valueChange)="emitFilterChanged()"
                         placeholder="To"
                         data-test="meetings-filter-to-date"></dx-date-box>
        </div>
    </div>

    <div class="form-group d-flex flex-column gap-1">
        <label>Display options for past meetings</label>
        <dx-check-box text="Show agenda item descriptions"
                      [(value)]="currentFilter.displayAgendaItemDescriptions"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
        <!-- Can't attach adaptTooltip to disabled dx-check-box - use wrapping div -->
        <div
             [adaptTooltip]="currentFilter.showDecisions || currentFilter.showMinutes || currentFilter.showActions || currentFilter.showObjectives ? undefined : 'This option is only available when filtering by decisions, minutes, actions or objectives.'">
            <dx-check-box text="Show all agenda items"
                          [disabled]="!(currentFilter.showDecisions || currentFilter.showMinutes || currentFilter.showActions || currentFilter.showObjectives)"
                          [(value)]="currentFilter.displayAllAgendaItems"
                          (valueChange)="emitFilterChanged()"></dx-check-box>
        </div>
    </div>
</adapt-filter-content>
